module.exports = __webpack_public_path__ + "io.0c878991b1aca651c7fe.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/io.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/io.svg
// module chunks = styles